export enum ToggleButtonText {
  ViewMore = 'View More',
  ViewLess = 'View Less'
}